export enum ASSURANCE_CHECK_FIELD_ID {
  FAKE_RECEIPT_DETECTION = 'ASSR01',
  VENDOR_LEGITIMACY = 'ASSR02',
  AMOUNT_ANOMALY_DETECTION = 'ASSR03',
  ALCOHOL_DETECTION = 'ASSR04',
  OUTSIDE_BUSINESS_HOURS = 'ASSR05',
  EXCESSIVE_TIP_DETECTION = 'ASSR06',
  LINE_ITEM_MISMATCH = 'ASSR08',
  ITEMIZED_MEAL_RECEIPT_CHECK = 'ASSR09'
}

export type ASSURANCE_CHECK_FIELD_ID_TYPE = `${ASSURANCE_CHECK_FIELD_ID}`;

export enum ASSURANCE_STATUS {
  PASS = 'pass',
  FAIL = 'fail'
}

export type ASSURANCE_STATUS_TYPE = `${ASSURANCE_STATUS}`;
export const ASSURANCE_STATUS_VALUES = Object.values(ASSURANCE_STATUS);

export type ASSURANCE_IMAGE_METADATA = {
  status: ASSURANCE_STATUS_TYPE;
  result?: string;
  is_visible_for_expense?: boolean;
  has_comment?: boolean;
};
export type IMAGE_METADATA_ASSURANCE_RESULT_TYPE = Partial<Record<ASSURANCE_CHECK_FIELD_ID_TYPE, ASSURANCE_IMAGE_METADATA>>;

export type ERT_RESULT_TYPE = {
  scan_id?: string;
  ert_amount?: number;
  ert_date?: string;
  ert_merchant?: string;
  ert_currency?: string;
  ert_submitted_at?: number;
  ert_status?: string;
  ert_category?: string;
  ert_tips_amount?: number;
  ert_last4?: string;
};
